import { render, staticRenderFns } from "./buyOneGetOne.vue?vue&type=template&id=4a230310&"
import script from "./buyOneGetOne.vue?vue&type=script&lang=ts&"
export * from "./buyOneGetOne.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports